













import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    activeTab: {
      type: [String, Object],
      default: null
    },
    items: {
      type: Array,
      default: []
    }
  }
})
export default class MiniTabs extends Vue {
  changeTab (active: any) {
    this.$emit('change', active)
  }
}
